<template lang="pug">
  el-header(:class="$style.header")
    el-row(align="middle")

      change-password-modal(
        :show="showChangePassword"
        align="left"
        @closeDialog="showChangePassword=false"
      )

      el-col(:span="4" align="center")
        router-link(:to="{ name: PAGE_MASTER }")
          img(:class="$style.logo" src="~@/assets/HVU_Logo.svg")

      el-col(:span="20")
        el-menu(
          :class="$style.menu"
          mode="horizontal"
          background-color="#f9f9f9"
          text-color="black"
        )
          el-menu-item(index="4")
            profile(
              :username="user.name"
              :email="user.email"
              :show="showProfile"
              v-click-outside="hideProfile"
              @onShowPasswordChange="showChangePassword=!showChangePassword"
              @click.native="showProfile=!showProfile")

          router-link(
            :to="{ name: PAGE_CREATE_COURSE }"
          ) 
            el-menu-item(index="2") Create a New Course

          router-link(
            :to="{ name: PAGE_APPLICATION_LIST }"
          )
            el-menu-item(index="3")
              el-badge(
                class="badge" 
                :value="notification.nApplications"
                :hidden="!notification.nApplications"
              ) Instructor Applications

          router-link(
            :to="{ name: PAGE_MASTER }"
          ) 
            el-menu-item(index="2") Courses
</template>

<script>
  import { mapState } from 'vuex'
  import ChangePasswordModal from '@/components/ChangePasswordModal'
  import Profile from '@/components/Profile'
  import { isSuperAdmin, isAdmin } from 'globalUtils/isAdmin'

  import { ACTION_LOGOUT } from '@/store/actions'
  import {
    PAGE_MASTER,
    PAGE_COURSE_LIST,
    PAGE_LOGIN,
    PAGE_APPLICATION_LIST,
    PAGE_CREATE_COURSE,
  } from '@/masteradmin/router/routeNames'

  export default {
    components: {
      Profile,
      ChangePasswordModal,
    },

    data() {
      return {
        PAGE_MASTER,
        PAGE_COURSE_LIST,
        PAGE_LOGIN,
        PAGE_APPLICATION_LIST,
        PAGE_CREATE_COURSE,
        showProfile: false,
        showChangePassword: false,
      }
    },

    computed: {
      ...mapState({
        user: state => state.user.user,
        notification: state => state.user.notification,
      }),
    },

    methods: {
      isSuperAdmin,
      isAdmin,

      logout() {
        return this.$store.dispatch(ACTION_LOGOUT)
          .then(() => {
            this.$router.push({ name: PAGE_LOGIN })
          })
      },

      hideProfile() {
        this.showProfile = false
      },
    },
  }
</script>

<style module>
  .header {
    background-color: #f9f9f9;
    width: 100vw;
    text-align: center;
  }

  .logo {
    width: 150px;
    padding-top: 10px;
  }

  .menu {
    border: none !important;
    
    & li {
      float: right !important;
      margin: 0px 20px * * !important;
      border-bottom: 2px solid #008000 !important;
      height: 56px !important;
    }

    & a {
      text-decoration: none;
    }
  }
</style>

<style>
  .badge .el-badge__content.is-fixed {
    top: 20px;
    right: -8px;
  }
</style>



// WEBPACK FOOTER //
// client/masteradmin/components/HeaderComponent/HeaderComponent.vue